import Header from "./Header";
import Footer from "./Footer";

export const Layout = ({ children }) => {
  return (
    <div className="App" data-testid="layout-root">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
